import fileDefault from '../assets/images/uploadicon.svg';
import fileCSS from '../assets/images/uploadicon.svg';
import filePdf from '../assets/images/uploadicon.svg';
import filePng from '../assets/images/uploadicon.svg';

// Define a type for the image configuration
type ImageConfigType = {
    [key: string]: string; // Keys are strings and values are image paths (strings)
};

export const ImageConfig: ImageConfigType = {
    default: fileDefault,
    pdf: filePdf,
    png: filePng,
    css: fileCSS
};
